<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-04-17 14:31:15
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-04-24 16:01:59
 * @FilePath: \watherfocast2\src\views\Statistics.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%
-->
<template>
  <div class="statisticsBody">
    <div class="staBoxHeaderBox">
      <div class="header-left">
        <i class="el-icon-s-data header-icon"></i>
        <span class="header-title">水电站精细化来水预测平台</span>
      </div>
      <div class="header-center">
        <div class="nav-tabs">
          <div class="nav-tab active" @click="goToStatistics">
            <i class="el-icon-data-analysis"></i>
            <span>查询统计</span>
          </div>
          <div class="nav-tab" @click="goToPrediction">
            <i class="el-icon-s-marketing"></i>
            <span>预测分析</span>
          </div>
          <!-- <div class="nav-tab" v-if="isAdmin" @click="goToAdminPermission">
            <i class="el-icon-s-custom"></i>
            <span>权限管理</span>
          </div> -->
        </div>
      </div>
      <div class="header-right">
        <el-button type="text" class="back-btn" @click="goBack">
          <i class="el-icon-back"></i>
          返回首页
        </el-button>
      </div>
    </div>
    <div class="staMainBox">
      <div class="statSildBox">
      <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      router
      >

      <el-menu-item index="/Statistics/RainfallData">
        <i class="el-icon-setting"></i>
        <span slot="title" >雨量数据</span>
      </el-menu-item>
       <el-menu-item index="/Statistics/ForecastData">
        <i class="el-icon-setting"></i>
        <span slot="title">预测数据</span>
      </el-menu-item>
       <!-- <el-menu-item index="/Statistics/VerificationResult">
        <i class="el-icon-setting"></i>
        <span slot="title">检验结果</span>
      </el-menu-item> -->
       <el-menu-item index="/Statistics/WarnList">
        <i class="el-icon-warning"></i>
        <span slot="title">预警列表</span>
      </el-menu-item>
    </el-menu>

    </div>
    <div class="statSildMainBox">
      <router-view style="width:100%;height:100%"></router-view>
    </div>
    </div>
    
  </div>
</template>

<script>
import { isAdmin as hasAdminRole } from '../utils/auth'

export default {
  computed: {
    isAdmin() {
      return hasAdminRole()
    },
    activeIndex() {
      return this.$route.path
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    goBack() {
      this.$router.push('/')
    },
    goToStatistics() {
      // 当前已在查询统计页面
      if (!this.$route.path.startsWith('/Statistics')) {
        this.$router.push('/Statistics/RainfallData')
      }
    },
     goToPrediction() {
      this.$router.push({ name: 'Predictive' })
    },
    goToAdminPermission() {
      this.$router.push('/admin')
    },
  }
}
</script>

<style>
.statisticsBody{
  height: 100vh;
  width: 100vw;
  background-color: #f5f5f5;
  /* display: flex; */
}
.statSildBox{
  height: 100%;
  width: 15%;
  background-color: #fff;
}

.statSildBox .el-menu-item {
  font-size: 16px;
}

.statSildBox .el-menu-item i {
  font-size: 18px;
}
.statSildMainBox{
  height: 100%;
  width: 85%;
  padding: 15px;
  /* background-color: #2ae983; */
}
.staBoxHeaderBox{
  height: 8vh;
  width: 100%;
  background: linear-gradient(135deg, #0F1F39 0%, #1a3a5c 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
}

.header-left {
  display: flex;
  align-items: center;
}

.header-icon {
  font-size: 28px;
  color: #00d8ff;
  margin-right: 12px;
}

.header-title {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 2px;
}

.header-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-tabs {
  display: flex;
  gap: 20px;
}

.nav-tab {
  display: flex;
  align-items: center;
  padding: 10px 24px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 15px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
  border: 1px solid transparent;
}

.nav-tab:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-tab.active {
  color: #00d8ff;
  background-color: rgba(0, 216, 255, 0.15);
  border-color: rgba(0, 216, 255, 0.4);
}

.nav-tab i {
  margin-right: 8px;
  font-size: 16px;
}

.header-right {
  display: flex;
  align-items: center;
}

.back-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 14px;
  padding: 8px 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  transition: all 0.3s;
}

.back-btn:hover {
  color: #fff !important;
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

.back-btn i {
  margin-right: 5px;
}
.staMainBox{
  height: 92vh;
  width: 100%;
  background-color: #fff;
  display: flex;
}
</style>